import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { NotificationType, NotificationTypeEnum } from './types';

export const Title = styled.span``;

export const Message = styled.div`
  position: relative;
`;

type NotificationProps = {
  type: NotificationType;
};

export const Notification = styled.div<NotificationProps>(
  props => css`
    border-radius: 5px;

    ${props.type === NotificationTypeEnum.ISSUE &&
      css`
        padding: ${layout.measurements.spacing100};
        background: ${props.theme.notifications.issue.bg};
        color: ${props.theme.notifications.issue.fg};

        ${Title} {
          color: ${props.theme.notifications.issue.fg};
        }

        ${Message} {
          &:not(:last-of-type) {
            margin-bottom: ${layout.measurements.spacing100};
          }
        }
      `}

    ${props.type === NotificationTypeEnum.INFO &&
      css`
        background: ${props.theme.notifications.info.bg};
        font-size: ${layout.measurements.fontSizeSmall};
        color: ${props.theme.notifications.info.fg};

        ${Message} {
          display: flex;
          justify-content: space-between;
          color: ${props.theme.notifications.info.fg};
          padding: ${layout.measurements.spacing100};

          p {
            margin: 0;
            margin-right: ${layout.measurements.spacing050};
          }

          > svg {
            margin: 0 ${layout.measurements.spacing050};
          }
        }
      `}

      ${props.type === NotificationTypeEnum.NEUTRAL &&
        css`
          padding: ${layout.measurements.spacing100};
          background: ${props.theme.notifications.neutral.bg};
          color: ${props.theme.notifications.neutral.fg};

          ${Title} {
            color: ${props.theme.notifications.neutral.fg};
          }

          ${Message} {
            &:not(:last-of-type) {
              margin-bottom: ${layout.measurements.spacing100};
            }
          }
        `}
  `
);

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const Date = styled.span``;

export const MessageText = styled.p`
  max-width: 650px;
  margin: 0;
`;

export const Divider = styled.div`
  &::after {
    content: '|';
    margin-left: ${layout.measurements.spacing025};
    margin-right: ${layout.measurements.spacing025};
  }
`;

export const LinkText = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span`
  white-space: nowrap;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: ${layout.measurements.spacing050};
  right: ${layout.measurements.spacing050};
`;
